{
	"accounts": "Cuentas",
	"addAccount": "Añadir cuenta",
	"exportExcel": "Exportar a excel",
	"importExcel": "Importar a excel",
	"payable": "A pagar",
	"receivable": "Cuenta por cobrar",
	"emptyText": "No se encontró ninguna cuenta",
	"isPaidYes": "Sí",
	"isPaidNo": "No",
	"buttonActions": {
		"markAsPaid": "Marcar como pagado",
		"unMarkAsPaid": "Desmarcar como pagado",
		"markAsReceived": "Marcar como recibido",
		"unMarkAsReceived": "Desmarcar como recibido",
		"viewDetails": "Ver detalles",
		"viewEdit": "Ver/Editar"
	},
	"status": {
		"all": "Todos",
		"payabled": "Pagado",
		"recivabled": "Recibido",
		"late": "Atrasado",
		"conciliated": "Conciliado",
		"payablePending": "Por pagar",
		"receivablePending": "Por recibir",
		"payableToday": "Pagar hoy",
		"receivableToday": "Recibir hoy"
	},
	"titleAccountPayable": "Cuentas por Pagar",
	"excelFileNamePayable": "cuentas_por_pagar",
	"titleAccountReceivable": "Cuentas por Cobrar",
	"excelFileNameReceivable": "cuentas_por_cobrar",
	"form": {
		"newAccountPayable": "Nueva cuenta por pagar",
		"editAccountPayable": "Editar cuenta por pagar",
		"newAccountReceivable": "Nueva cuenta por recibir",
		"editAccountReceivable": "Editar cuenta por recibir",
		"informOfPayments": "Información de pagos",
		"postingInformation": "Información de publicación",
		"lblSupplier": "Proveedor",
		"lblClient": "Cliente",
		"phSupplier": "Seleccionar proveedor",
		"lblDocNumber": "Número de documento",
		"phDocNumber": "Insertar número de documento",
		"lblInvoiceDate": "Fecha de devengo",
		"phInvoiceDate": "Seleccionar fecha de devengo",
		"lblPaymentDate": "Fecha de pago",
		"phPaymentDate": "Seleccionar fecha de pago",
		"lblDueDate": "Fecha de vencimiento",
		"phDueDate": "Seleccionar fecha de vencimiento",
		"lblDescription": "Descripción",
		"phDescription": "Insertar descripción",
		"phValue": "Insertar valor",
		"lblValue": "Valor",
		"lblPaymentMethod": "Método de pago",
		"phPaymentMethod": "Seleccionar método de pago",
		"lblAccountId": "Cuenta bancaria",
		"phAccountId": "Seleccionar cuenta bancaria",
		"lblCostCenter": "Centro de Costo",
		"phCostCenter": "Seleccionar centro de costo",
		"lblChartAccounts": "Plan de cuentas",
		"phChartAccounts": "Seleccionar plan de cuentas",
		"ttRequiredWhenFilled": "Campo obligatorio cuando se rellena 'Intereses de mora'",
		"lblInterest": "Intereses de mora",
		"phInterest": "Seleccione intereses vencidos",
		"lblFine": "Retraso fino",
		"phFine": "Seleccionar cargo por pago atrasado",
		"lblDiscount": "Descuentos",
		"phDiscount": "Seleccionar descuentos",
		"lblPaidValue": "Cantidad pagada",
		"phPaidValue": "Seleccione el monto pagado",
		"phZeroValue": "0.00",
		"swtIsPaid": "Pagado",
		"swtIsReceived": "Recebió",
		"swtConciliated": "Reconciliado",
		"swtTotalValue": "Valor total:",
		"recurringPayment": "Pago recurrente",
		"lblRecurringPaymentInterval": "Repetir cada",
		"phRecurringPaymentInterval": "Ingrese intervalo",
		"oneTime": "Una vez",
		"recurring": "Valor recurrente",
		"installment": "Valor en cuotas",
		"lblInstallmentCount": "Número de cuotas",
		"phInstallmentCount": "Ingrese el número de cuotas",
		"lblInstallmentInterval": "Repetir cada",
		"phInstallmentInterval": "Ingrese el intervalo",
		"lblInstallmentTypeInterval": "Intervalo",
		"phInstallmentTypeInterval": "Seleccione el tipo de intervalo",
		"installmentSummary": "Valor total de {{total}} dividido en {{count}} cuotas",
		"lblInstallmentBetween": "Intervalo entre las cuotas",
		"phInstallmentBetween": "Seleccione el intervalo",
		"lblInstallmentFirstDueDate": "Vencimiento de la primera cuota",
		"lblInstallmentFirstCompetenceDate": "Fecha de competencia de la primera cuota",
		"installmentPeriodicity": {
			"Day": "Diario",
			"Week": "Semanal",
			"Month": "Mensual",
			"Year": "Anual"
		},
		"lblRecurringPaymentTypeInterval": "Intervalo",
		"phRecurringPaymentTypeInterval": "Seleccionar tipo de intervalo",
		"lblRecurringPaymentTimes": "¿Cuántas veces?",
		"phRecurringPaymentTimes": "Ingrese número de veces",
		"totalRepetition": "Repetición en ",
		"recurringEnd": "Fin de recurrencia:",
		"observation": "Observación",
		"attachment": "Adjunto",
		"lblObservation": "Insertar observación",
		"lblAttachment": "Haga clic para adjuntar archivos",
		"validations": {
			"dueDate": "Ingrese la fecha de vencimiento para continuar",
			"value": "Ingrese valor para continuar",
			"chartAccounts": "Seleccione plan de cuentas para continuar",
			"discountGreaterThanBill": "El descuento no puede ser mayor que el valor de la cuenta",
			"recurringPaymentInterval": "Ingrese el intervalo de pago recurrente",
			"recurringPaymentTypeInterval": "Seleccione el tipo de intervalo de pago recurrente",
			"recurringPaymentTimes": "Ingrese el número de veces del pago recurrente",
			"recurringPaymentTimesMax": "El número máximo de recurrencias permitido es 48",
			"installmentCount": "Ingrese el número de cuotas (mínimo 2)",
			"installmentCountMax": "El número máximo de cuotas permitido es 48",
			"installmentInterval": "Ingrese el intervalo entre las cuotas",
			"installmentTypeInterval": "Seleccione el tipo de intervalo",
			"paymentDate": "Ingrese la fecha de pago para continuar"
		},
		"modalDelete": {
			"title": "Eliminar cuenta",
			"cancelText": "Cancelar",
			"okText": "Eliminar cuenta",
			"message": "La eliminación de la cuenta es una acción final. ¿Desea continuar con la eliminación?"
		}
	},
	"columns": {
		"docNumber": "NÚMERO DE DOCUMENTO",
		"supplier": "PROVEEDOR",
		"client": "CLIENTE",
		"chartOfAccount": "PLAN DE CUENTAS",
		"dueDate": "FECHA DE VENCIMIENTO",
		"invoiceDate": "FECHA DE ACEPTACIÓN",
		"paymentDate": "FECHA DE PAGO",
		"value": "VALOR",
		"situation": "SITUACIÓN",
		"paymentMethod": "MÉTODO DE PAGO",
		"actions": "ACCIONES"
	},
	"chartAccounts": "Plan de cuentas",
	"placeholderChartAccounts": "Seleccionar plan de cuentas",
	"labelFilter": "Haga clic para filtrar",
	"selectSupplier": "Filtrar por proveedor",
	"lblDocNumber": "Filtrar por número de documento",
	"phDocNumber": "Ingrese el número a filtrar",
	"lblPaymentDate": "Filtrar por fecha de pago",
	"lblDueDate": "Filtrar por fecha de vencimiento",
	"lblInvoiceDate": "Filtrar por fecha de devengo",
	"tzOverdue": "Atrasado",
	"tzmaturing": "Paga hoy",
	"tzDue": "Por vencer",
	"tzDelayed": "Atrasado",
	"tzPaid": "Pagado",
	"tzTotal": "Total del período",
	"tzReceived": "Recibido",
	"tzRecivabledToday": "Recibir hoy",
	"attatchmentDescription": "Adjunte recibos de pago u otros documentos relacionados con esta cuenta para no perderlos de vista. Se permiten hasta 4 documentos en formatos PDF, OFX, XML, XLS, JPG y PNG con hasta 5MB.",
	"attachFile": "Haga clic para adjuntar un archivo",
	"attachImportError": {
		"existingFile": "Archivo ya importado",
		"exceededSize": "Se superó el límite de tamaño. El archivo adjunto no debe tener más de 5 MB."
	},
	"attachModal": {
		"title": "Adjuntos de cuenta",
		"noAttachments": "No se encontraron archivos adjuntos en este momento",
		"table": {
			"columns": {
				"attachedFiles": "Archivos adjuntos"
			},
			"successfullyDeletedFile": "Archivo eliminado",
			"errorDeleted": "No se puede eliminar el archivo"
		}
	},
	"attachedToChartAccountsModal": {
		"linksPlural": "{{chartAccounts}} vinculos",
		"linksSingular": "1 vinculo",
		"seeLinks": "Ver vinculos",
		"title": "Vinculo con Plan de Cuentas",
		"description": "Relación de registro con la que se vincula este artículo"
	},
	"modalPayment": {
		"title": "Marcar como pagado",
		"titleReceivable": "Marcar como recibido",
		"paymentMethod": "Método de pago",
		"selectPaymentMethod": "Seleccionar método de pago",
		"interests": "Juros por atraso",
		"fine": "Multa por atraso",
		"discount": "Descuentos",
		"financialFees": "Cargos administrativos",
		"description": "Seleccione la fecha del pago y la cuenta bancaria en la que desea registrar el pago",
		"descriptionReceivable": "Seleccione la fecha del recibo y la cuenta bancaria en la que desea registrar el recibo",
		"paymentDate": "Fecha de pago",
		"receiptDate": "Fecha de recibo",
		"paymentAccount": "Cuenta bancaria",
		"selectAccount": "Seleccionar una cuenta bancaria",
		"required": "Por favor seleccione una fecha de pago",
		"cancel": "Cancelar",
		"confirm": "Confirmar",
		"addAccount": "Adicionar cuenta",
		"deletedAccount": "Cuenta eliminada",
		"placeholderChartOfAccounts": "Seleccionar plan de cuentas",
		"placeholderZeroValue": "0,00",
		"errors": {
			"paymentDate": {
				"required": "Fecha de pago es obligatoria",
				"invalid": "Formato de fecha inválido",
				"future": "La fecha no puede ser posterior a la fecha de apertura del registro"
			},
			"paymentAccount": {
				"required": "Cuenta bancaria es obligatoria"
			},
			"requiredChartOfAccounts": "Seleccione un plan de cuentas",
			"requiredValue": "Ingrese el valor",
			"discountGreaterThanBill": "El descuento no puede ser mayor que el valor de la cuenta"
		}
	},
	"lblPaymentStatus": "Estado de pago",
	"optPaymentStatusAll": "Todos",
	"optPaymentStatusPaid": "Pagado",
	"optPaymentStatusNotPaid": "No pagado",
	"optReceivabledStatus": "Recibido",
	"optNotReceivabledStatus": "No recibido",
	"startDate": "Fecha inicial",
	"endDate": "Fecha final",
	"print": "Imprimir",
	"lblFinancialFees": "Cargos administrativos",
	"phFinancialFees": "Seleccionar cargos administrativos",
	"drawer": {
		"titlePayable": "Cuenta por pagar",
		"titleReceivable": "Cuenta por cobrar",
		"titlePayableEdit": "Editar cuenta por pagar",
		"titleReceivableEdit": "Editar cuenta por cobrar",
		"titlePayableView": "Visualizar cuenta por pagar",
		"titleReceivableView": "Visualizar cuenta por cobrar",
		"tabs": {
			"launch": "Registro",
			"attachments": "Adjuntos",
			"recurrencesSummary": "Resumen de recurrencias",
			"editHistory": "Historial de edición",
			"installment": "Cuota",
			"installmentPaid": "Registro",
			"installmentSummary": "Resumen total del registro",
			"installmentSummaryPaid": "Resumen del pago"
		},
		"sections": {
			"generalInfo": "Información general",
			"details": "Detalles"
		},
		"attachments": {
			"dropTitle": "Arrastre y suelte los archivos aquí",
			"dropSelect": "o seleccione los archivos",
			"allowedFormats": "Se permiten hasta 4 documentos en formatos PDF, OFX, XML, XLS, JPG y PNG con hasta 1.5MB.",
			"of": "de",
			"filesLabel": "archivos"
		},
		"markAsPaid": "¿Pagado?",
		"markAsReceived": "¿Recibido?",
		"lblReceiptDate": "Fecha de recepción",
		"phReceiptDate": "Seleccionar fecha de recepción",
		"errors": {
			"paymentDate": {
				"future": "La fecha no puede ser posterior a la fecha de apertura del registro"
			}
		},
		"footer": {
			"totalValue": "Valor total:",
			"submit": "Registrar lanzamiento",
			"submitUpdate": "Guardar cambios",
			"badgeAVista": "AL CONTADO",
			"badgeRecorrente": "RECURRENTE",
			"recurringWillLaunch": "Se lanzarán",
			"recurringRecurrencesOf": "recurrencias de",
			"recurringEvery": "cada",
			"installmentSplitIn": "dividido en",
			"installmentTimesEvery": "veces cada",
			"installmentParcelValue": "Valor de la cuota",
			"installmentTotalOf": "Valor total de",
			"installmentDividedIn": "dividido en",
			"installmentParcelsWord": "cuotas"
		},
		"tooltips": {
			"recurring": "Crea registros repetidos automáticamente con una frecuencia definida.",
			"installmentNotRecurring": "El registro en cuotas no puede ser recurrente.",
			"markAsPaid": "Marca el registro como pagado e informa los datos del pago.",
			"markAsReceived": "Marca el registro como recibido e informa los datos del cobro."
		},
		"recurrencesSummary": {
			"emptyText": "No se encontraron recurrencias.",
			"distributionTitle": "Distribución de las recurrencias",
			"columns": {
				"sequence": "Cuota",
				"dueDate": "Fecha de vencimiento",
				"finalValue": "Valor final",
				"status": "Estado"
			}
		},
		"installmentSummary": {
			"summaryTitle": "Resumen del registro",
			"totalValue": "Valor",
			"type": "Tipo",
			"typeInstallment": "Valor en cuotas",
			"typeAVista": "Valor al contado",
			"quitButton": "Liquidar pago",
			"numberOfInstallments": "Número de cuotas",
			"firstDueDate": "Fecha de vencimiento",
			"interval": "Intervalo entre las cuotas",
			"distributionTitle": "Distribución de las cuotas",
			"emptyText": "Ninguna cuota encontrada.",
			"hasCharges": "Cuota con intereses, multa o descuento",
			"totalizerTotalAmount": "Valor total de las cuotas",
			"totalizerInterest": "Total intereses pagados",
			"totalizerFine": "Total multas pagadas",
			"totalizerDiscount": "Total descuentos obtenidos",
			"totalizerPaid": "Valor total pagado hasta ahora",
			"blockedBanner": "No es posible editar este lanzamiento porque ya hay cuotas pagadas."
		},
		"editHistory": {
			"tabLabel": "Historial de edición",
			"emptyText": "Sin historial de cambios.",
			"installmentTag": "Cuota {{number}}/{{total}}",
			"columns": {
				"action": "Acción",
				"user": "Usuario",
				"dateTime": "Fecha y hora"
			},
			"user": {
				"system": "Sistema"
			},
			"fields": {
				"valor": "valor",
				"juros": "intereses por mora",
				"multa": "multa por mora",
				"desconto": "descuento",
				"taxasAdministrativas": "tasas administrativas",
				"valorPago": "valor pagado",
				"valorRecebido": "valor recibido",
				"dataDeVencimento": "fecha de vencimiento",
				"dataDeCompetencia": "fecha de competencia",
				"dataDePagamento": "fecha de pago",
				"dataDeRecebimento": "fecha de recepción",
				"formaDePagamento": "forma de pago",
				"formaDeRecebimento": "forma de recepción",
				"contaBancaria": "cuenta bancaria",
				"fornecedor": "proveedor",
				"numeroDoDocumento": "número de documento",
				"descricao": "descripción",
				"observacao": "observación",
				"statusDePagamento": "estado de pago",
				"statusDeRecebimento": "estado de recepción",
				"conciliacao": "conciliación",
				"planoDeContas": "plan de cuentas"
			},
			"badges": {
				"created": "Registro creado",
				"paymentAdded": "Marcado como pagado",
				"paymentAddedReceivable": "Marcado como recibido",
				"reconciled": "Conciliado",
				"deleted": "Registro eliminado",
				"unknown": "Registro actualizado"
			},
			"events": {
				"updatedTo": "Cambió {{field}} a {{toValue}}"
			}
		},
		"modalDeleteInstallment": {
			"title": "¿Eliminar lanzamiento en cuotas?",
			"message": "Se eliminarán las {{total}} cuotas. Esta acción no se puede deshacer.",
			"messageWithPaid": "Se eliminarán las {{total}} cuotas, incluidas las ya pagadas — los asientos pagados se revertirán del Flujo de Caja y de la DRE. Esta acción no se puede deshacer.",
			"cancelText": "Cancelar",
			"okText": "Eliminar"
		}
	}
}
